export default {
    label_task:{
        en:"Distributors Target",
        bn:'ব্যবহারকারীরা'
    },
    label_new_task:{
        en:"New Distributor Target",
        bn:'নতুন ব্যবহারকারী'
    },
    label_edit_task:{
        en:"Edit Distributor Target",
        bn:'সম্পাদনা ব্যবহারকারী'
    },
    label_details_task:{
        en:"Details of Distributor Target",
        bn:'ব্যবহারকারীর বিবরণ'
    },
}